import { ng } from '@uirouter/angularjs/lib/angular';
import * as angular from 'angular';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { BlobService } from '../../../app.common/modules/common/services/blob.service';
import { RetailerService } from '../api/retailer.service';
import { IStore } from './models/store.interface';

export class PublisherSettingsService {
    public static $inject = ['http', 'retailerService', 'blobService'];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService,
        private blobService: BlobService
    ) {
    }

    public getStores(): Promise<IStore[]> {
        return this.http.get(this.retailerService.allStores());
    }

    public savePublisherName(storeId: number, name: string): Promise<boolean> {
        return this.http.put(this.retailerService.savePublisher(storeId), {Name: name});
    }

    public deleteLogo(logoId: number): Promise<boolean> {
        return this.http.delete(this.retailerService.storeLogo(logoId));
    }

    public uploadImage(storeId: number, dataUri: string): angular.IPromise<number> {
        const form = new FormData();
        form.append('FileImage', this.blobService.dataUriToBlob(dataUri));
        const config: ng.IRequestShortcutConfig = {
            transformRequest: angular.identity,
            headers: { 'Content-Type': undefined }
        };
        return this.http.post<number>(this.retailerService.storeLogo(storeId), form, config);
    }

}

angular
    .module('naut')
    .service('publisherSettingsService', PublisherSettingsService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/publisher-settings/publisher-settings.service.ts